<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-二手车-修改
    -->
  <el-dialog
    title="修改二手车"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >
    <div class="product-add pb50">
      <el-form
        size="small"
        :model="form"
        ref="form"
        :rules="rules"
        label-width="100px"
      >

  
        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入名称" class="max-w460"></el-input>
        </el-form-item>

         
        <el-form-item label="价格" prop="price">
          <el-input v-model="form.price" placeholder="请输入价格" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="型号" prop="model">
          <el-input v-model="form.model" placeholder="请输入型号" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="详情" prop="intro">
          <el-input v-model="form.intro" placeholder="请输入详情" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="品牌" prop="brand">
          <el-input v-model="form.brand" placeholder="请输入品牌" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="年份" prop="year">
          <el-input v-model="form.year" placeholder="请输入年份" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="年限" prop="duration">
          <el-input v-model="form.duration" placeholder="请输入年限" class="max-w460"></el-input>
        </el-form-item>
    
       
        <el-form-item label="发动机小时" prop="e_hour">
          <el-input v-model="form.e_hour" placeholder="请输入发动机小时" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="风机小时" prop="wt_hour">
          <el-input v-model="form.wt_hour" placeholder="请输入风机小时" class="max-w460"></el-input>
        </el-form-item>

        <el-form-item label="审核状态" prop="status">
          <el-radio-group v-model="form.status">
            <el-radio :label="0">未审核</el-radio>
            <el-radio :label="1">审核通过</el-radio>
            <el-radio :label="2">审核未通过</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="图片：" prop="model.images">
          <div class="draggable-list">
            <draggable class="wrapper" v-model="form.images">
              <transition-group>
                <div v-for="(item, index) in form.images" :key="item.file_path">
                  <div class="item">
                    <img v-img-url="item.file_path" alt="item" />
                    <a
                      href="javascript:void(0);"
                      class="delete-btn"
                      @click.stop="deleteImg(index, 'album')"
                      ><i class="el-icon-close"></i
                    ></a>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <div class="item img-select" @click="openProductUpload('album')">
              <i class="el-icon-plus"></i>
            </div>
          </div>
        </el-form-item>


         <el-tabs v-model="selectMap">
            <el-tab-pane label="地址" name="1">
              <div>
                <el-form-item label="地址" prop="address">
                  <el-input
                    v-model="form.address"
                    placeholder="请输入地址"
                    class="max-w460"
                  ></el-input>
                </el-form-item>
                <el-form-item label="坐标" prop="coordinate">
                  <el-row class="mb16">
                    <el-col :span="24">
                      <el-input
                        v-model="form.coordinate"
                        class="max-w460"
                      ></el-input>
                    </el-col>
                  </el-row>
                  <el-row class="mb16">
                    <el-col :span="24">
                      <Getpoint
                        v-if="selectMap == 1"
                        :form="form"
                        @getMapdata="getMapdataFunc"
                        @chose="choseFunc"
                      ></Getpoint>
                    </el-col>
                  </el-row>
                </el-form-item>
              </div>
            </el-tab-pane>
          </el-tabs>

        <el-form-item label="排序" prop="name"
          ><el-input
            v-model="form.sort"
            placeholder="请输入排序"
            class="max-w460"
          ></el-input
        ></el-form-item>

        <!--提交-->
        <div class="common-button-wrapper">
          <el-button size="small" type="info" @click="cancelFunc"
            >取消</el-button
          >
          <el-button
            size="small"
            type="primary"
            @click="onSubmit"
            :loading="loading"
            >提交</el-button
          >
        </div>
      </el-form>
      <Upload
        v-if="isProductUpload"
        :config="{ total: 9 }"
        :isupload="isProductUpload"
        @returnImgs="returnProductImgsFunc"
        >上传图片
      </Upload>
      <!-- <Categoryas :isproduct="iscategorya" :excludeIds="excludeIds" :islist="false" @closeDialog="closeDialogFunc"></Categoryas> -->
    </div>
  </el-dialog>
</template>

<script>
import UsedCarApi from "@/api/used_car.js";
import Getpoint from "@/components/map/Getpoint.vue";
import Upload from "@/components/file/Upload";
import Categoryas from "@/components/categorya/index.vue";
import draggable from "vuedraggable";
import Uediter from "@/components/UE.vue";
export default {
  components: {
    /*图片上传*/
    Upload: Upload,
    Categoryas,
    draggable,
    Uediter,
    Getpoint
  },
  data() {
    return {
      rescueServiceCatalogList: [],
      loadingRescueServices: false,
      selectMap: "1",
      /*是否上传图片*/
      isupload: false,
      isImg: false,
      /*富文本配置*/
      ueditor: {
        text: "",
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        title: "",
        model: "",
        price: "",
        intro: "",
        brand: "",
        year: "",
        exterior: "",
        fun_test: "",
        cs_test: "",
        cp_pressure: "",
        ec_pressure: "",
        e_hour: "",
        wt_hour: "",
        duration:'',
        images: [],
        sort: 50,

           address: "",
        coordinate: "",
        longitude: "",
        latitude: "",
      },
        
      loading: false,
      /*验证规则*/
      rules: {
        name: [
          {  }
        ]
      },
      dialogVisible: false,
      iscategorya: false,
      excludeIds: [],
      isProductUpload: false,
      code: "album"
    };
  },
  created() {
    this.dialogVisible = this.open_add;
    this.getDetail();
  },
  props: ["open_add", "used_car_id"],
  methods: {
    /*获取经纬度*/
    getMapdataFunc(e) {
      console.log(e);
      this.form.coordinate = e.data[0].toFixed(6) + "," + e.data[1].toFixed(6);
    },

    /*选择的地址*/
    choseFunc(e) {
      this.form.coordinate = e.location.lat + "," + e.location.lng;
      this.form.address = e.address;
    },
    /*上传*/
    openUpload(e) {
      this.isupload = true;
    },

    /*获取图片*/
    returnImgsFunc(e) {
      let self = this;
      if (e != null) {
        this.form.images_id = e[0].file_id;
        this.form.images = e[0].file_path;
        this.isImg = true;
      }
      this.isupload = false;
    },
    /*关闭弹窗*/
    dialogFormVisible(result) {
      this.$emit("close", {});
    },
    cancelFunc() {
      //取消
      this.dialogFormVisible("error");
    },
    getDetail() {
      let self = this;
      // 取到路由带过来的参数
      UsedCarApi.detail(
        { used_car_id: self.used_car_id },
        true
      )
        .then(res => {
          self.form = res.data;
          self.ueditor.text = self.form.intro;
          self.isImg = true;
          self.loading = false;
          if (!self.form.images) {
            self.form.images = [];
          }else{
            self.form.images = JSON.parse(self.form.images)
          }
        })
        .catch(error => {});
    },
    onSubmit() {
      let self = this;
      let form = self.form;

      form.used_car_id = self.used_car_id;

      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          UsedCarApi.edit(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: "success"
              });
              self.dialogFormVisible("error");
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消修改，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false, type: "" });
    },
    openProductUpload: function(code) {
      this.isProductUpload = true;
      this.code = code;
    },

    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if (this.code == "album") {
        if (e != null) {
          let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
          let prevent = false;
          
          e.forEach(element => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            imgExpt.forEach(e => {
              if (e === ext) {
                prevent = true;
                return false;
              }
            });

          });

          if (!prevent) {
            this.$message.error("图片类型有误,请选择正确的图片格式");
            return false;
          }
          const filePaths = e.map(item => item);
          let imgs = this.form.images.concat(filePaths);
          this.$set(this.form, "images", imgs);
        }
      }else if (this.code == "zz") {
        if (e != null) {
          let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
          let prevent = false;
          console.log(typeof imgExpt);
          e.forEach(element => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            imgExpt.forEach(e => {
              if (e === ext) {
                prevent = true;
                return false;
              }
            });
          });

          if (!prevent) {
            this.$message.error("图片类型有误,请选择正确的图片格式");
            return false;
          }

          let imgs = this.form.zz.concat(e);
          this.$set(this.form, "zz", imgs);
        }
      }else if (this.code == "idcard_positive") {
        if (e != null) {
          let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
          let prevent = false;
          console.log(typeof imgExpt);
          e.forEach(element => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            imgExpt.forEach(e => {
              if (e === ext) {
                prevent = true;
                return false;
              }
            });
          });

          if (!prevent) {
            this.$message.error("图片类型有误,请选择正确的图片格式");
            return false;
          }

          let imgs = this.form.idcard_positive.concat(e);
          this.$set(this.form, "idcard_positive", imgs);
        }
      }else if (this.code == "idcard_reverse") {
        if (e != null) {
          let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
          let prevent = false;
          console.log(typeof imgExpt);
          e.forEach(element => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            imgExpt.forEach(e => {
              if (e === ext) {
                prevent = true;
                return false;
              }
            });
          });

          if (!prevent) {
            this.$message.error("图片类型有误,请选择正确的图片格式");
            return false;
          }

          let imgs = this.form.idcard_reverse.concat(e);
          this.$set(this.form, "idcard_reverse", imgs);
        }
      } else {
        if (e != null) {
          let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
          let prevent = false;
          console.log(typeof imgExpt);
          e.forEach(element => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            imgExpt.forEach(e => {
              if (e === ext) {
                prevent = true;
                return false;
              }
            });
          });

          if (!prevent) {
            this.$message.error("图片类型有误,请选择正确的图片格式");
            return false;
          }

          let imgs = this.form.bannar.concat(e);
          this.$set(this.form, "bannar", imgs);
        }
      }

      this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(index, code) {
      if (code == "album") {
        this.form.images.splice(index, 1);
      } else if (code == "bannar") {
        this.form.bannar.splice(index, 1);
      }else if (code == "zz") {
        this.form.zz.splice(index, 1);
      }else if (code == "idcard_positive") {
        this.form.bannar.splice(index, 1);
      }else if (code == "idcard_reverse") {
        this.form.idcard_reverse.splice(index, 1);
      }
    }
  }
};
</script>

<style>
.edit_container {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/used_car/index/part/edit.vue